import React, { startTransition, useEffect, useRef, useState } from "react";
import HorecaWidget from "./horecaWidget/HorecaWidget";
import { Outlet, useLocation } from "react-router-dom";
import {
  getWidgetSetUpPosition,
} from "../api/HorecaWidget.service";
import { useDispatch, useSelector } from "react-redux";
import FeedbackComponent from "./feedbackWidget/FeedbackComponent";
import {
  updateButtonPosition,
  updateKey,
  updateResType,
  updateWidgetPosition,
  updateWidgetSetupId,
  updateFloating,
  updateWidgetConfig,
  updateLanguageData,
  updateGuestId,
} from "../store/slice/widgetSetting.slice";
import TicketingMain from "./ticketingWidget/TicketingMain";
import ActivityWidget from "./ActivitiesWidget/ActivitiesWidget";
import { updateDefaultLanguage } from "../store/slice/Addguest.slice";
import ScanWidget from "./ScanWidget/ScanWidget";
import {
  updateShopType,
  updateWebShopMenuPosition,
} from "../store/slice/Webshop.slice";
import ReservationBooking from "./ReservationBooking/ReservationBooking";
import ReservationOverviewComponent from "./ReservationOverview/ReservationOverviewComponent";

const WidgetDynamicLoading = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    widgetSetupId,

    key,
    buttonPosition,
    resType,
    widgetPosition,
    floating,
  } = useSelector((store) => store?.widgetSettings);
  const { shopType } = useSelector((store) => store?.widgetSettings);
  const { isBackToHoreca } = useSelector((store) => store?.addGuest);
  const setupIdRef = useRef(widgetSetupId);
  const[widgetPositionLoading,setWidgetPositionLoading]=useState(false)

  const fetchWidgetSetupPosition = async (widgetSetupId) => {
   
    if (widgetSetupId == setupIdRef.current) return;
    setupIdRef.current = widgetSetupId;
    setWidgetPositionLoading(true)
    try {
      const response = await getWidgetSetUpPosition(widgetSetupId);
      if (response?.status == 200) {
        startTransition(() => {
          dispatch(updateWidgetPosition(response?.data?.positionButton));
        });
      }
      setWidgetPositionLoading(false)
    } catch (error) {
      console.error("Error fetching widget settings:", error?.message);
      setWidgetPositionLoading(false)
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const setupId = queryParams.get("widgetsetupid");
    const keyParam = queryParams.get("key");
    const langParam = queryParams.get("lang");
    const buttonPositionParam = queryParams.get("buttonposition");
    const resTypeParam = queryParams.get("resType");
    const floatingParam = queryParams.get("floating");
    const position = queryParams.get("position");
    const shopType = queryParams.get("shoptype");
    const guestId=queryParams?.get('guestId')
    fetchWidgetSetupPosition(setupId);
    localStorage.setItem(
      "widget",
      JSON.stringify({
        id: setupId,
        key: keyParam,
        lang: langParam,
        resType:resTypeParam
      })
    );
    dispatch(updateWidgetSetupId(setupId));
    dispatch(updateKey(keyParam));
    dispatch(updateButtonPosition(buttonPositionParam));
    dispatch(updateResType(resTypeParam));
    dispatch(updateFloating(floatingParam));
    dispatch(updateWebShopMenuPosition(position));
    dispatch(updateShopType(shopType));
    dispatch(updateGuestId(guestId))
  }, [location]);


  if (key && resType?.toLowerCase() === "horeca") {
    return (
      <div>
        <HorecaWidget
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );
  } else if (key && resType?.toLowerCase() === "feedback") {
    return (
      <div>
        <FeedbackComponent
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
        />
      </div>
    );
  } else if (key && resType?.toLowerCase() === "ticketing") {
    return (
      <div>
        <TicketingMain
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );
  
  } else if (key && resType?.toLowerCase() === "activity") {
    return (
      <div>
        <ActivityWidget
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition || "Bottom-Right"}
          resType={resType}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </div>
    );
  } else if (key && resType?.toLowerCase() === "scan") {
    return (
      <div>
        <ScanWidget />
      </div>
    );
  } 
  else if (key && resType?.toLowerCase() === "reservation") {
    return (
      <div>
        <ReservationBooking floating={floating} />
      </div>
    );
    
  }
  else if (key && resType?.toLowerCase() === "reservationoverview") {
    return (
      <div>
        {/* <ReservationOverview /> */}
        <ReservationOverviewComponent />
      </div>
    );
    
  }
   else {
    return (
      <div>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    );
  }
};

export default WidgetDynamicLoading;
